export const SEARCH_AROUND_DISTANCES = [5, 20, 100];
